import React from 'react';
import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  to { transform: rotate(360deg); }
`;

const SpinnerWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: ${({ $fullPage }) => ($fullPage ? '60vh' : '200px')};
  width: 100%;
`;

const Spinner = styled.div`
  width: 42px;
  height: 42px;
  border: 3px solid ${({ theme }) => theme.colors.border};
  border-top-color: ${({ theme }) => theme.colors.gold};
  border-radius: 50%;
  animation: ${spin} 0.8s linear infinite;
`;

const LoadingSpinner = ({ fullPage }) => (
  <SpinnerWrapper $fullPage={fullPage}>
    <Spinner />
  </SpinnerWrapper>
);

export default LoadingSpinner;
